import React from "react";

// Trading Secret official silver/chrome logo
const TS_LOGO = "https://customer-assets-39nsmqrw.emergentagent.net/job_trading-secret-app/artifacts/tqq09lp6_grok-image-47a502f9-dab7-4608-87ed-9344731cbcb5.png";

export default function BrandLogo({ size = 40, hideText = false, variant = "dark" }) {
  const textColor = variant === "light" ? "text-white" : "text-slate-900";
  const subColor = variant === "light" ? "text-slate-300" : "text-slate-500";
  // On dark backgrounds the silver logo becomes hard to read; boost brightness slightly.
  const imgFilter = variant === "light" ? "brightness(1.15) drop-shadow(0 4px 12px rgba(0,180,255,0.25))" : "none";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={TS_LOGO}
        alt="Trading Secret"
        style={{ height: size, width: size, objectFit: "contain", filter: imgFilter }}
        className="select-none pointer-events-none"
      />
      {!hideText && (
        <div className="leading-tight">
          <div className={`font-display font-bold text-[15px] tracking-tight ${textColor}`}>Trading Secret</div>
          <div className={`text-[10px] tracking-[0.28em] font-mono-plex uppercase ${subColor}`}>LP • Partner</div>
        </div>
      )}
    </div>
  );
}

// Loyal Primus wordmark (official blue on white)
export const LP_LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_trading-secret-app/artifacts/gmzr7k0w_LP.png";

export function LoyalPrimusLogo({ className = "", height = 28 }) {
  return (
    <img
      src={LP_LOGO_URL}
      alt="LOYAL PRIMUS"
      style={{ height, width: "auto", objectFit: "contain" }}
      className={`select-none pointer-events-none ${className}`}
      data-testid="loyal-primus-logo"
    />
  );
}
